export default {"src":"/_next/static/media/LogoLight.2cfdcbfb.svg","height":24,"width":76,"blurWidth":0,"blurHeight":0};